import React from 'react';
import { useRouter } from 'next/router';
import { CountLabel } from '@creditflowresearch/uilib/Badge/CountLabel';
import { useInventoryTableContext } from '@/creditflowresearch/application/Bonds/InventoryTableContext';
import { useBwicTableContext } from '@/creditflowresearch/application/Bonds/BwicTableContext';
import { LABEL_COLOR_COUNT } from '@/creditflowresearch/ui/components/bonds/constants';

const BwicCountLabelContainer = (props) => {
  const { isInventoriesFetching } = useInventoryTableContext();
  const {
    isBwicFetching,
    bwicsData: { bwics: { totalCount: bwicsTotalCount } },
  } = useBwicTableContext();
  const {
    query: {
      q,
      hash,
    },
  } = useRouter();

  const canShowCount = (!isInventoriesFetching && !isBwicFetching) && (q || hash);

  return (
    <CountLabel
      { ...props }
      canShowCount={ canShowCount }
      backgroundColor={ LABEL_COLOR_COUNT }
      maxTotalCount={ 99 }
      totalCount={ bwicsTotalCount }
    />
  );
};

export default BwicCountLabelContainer;
